export default "__VITE_ASSET__BsDJ2vir__"